import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keyValue',
  standalone: true,
})
export class KeyValuePipe implements PipeTransform {
  transform(option: any, key: string): string {
    if (!option || !key) {
      return '';
    }

    const value = key.split('.').reduce((obj, k) => obj?.[k], option);

    return value;
  }
}
